module.exports = __webpack_public_path__ + "static/media/AvenirNext-UltraLight.8a513f2f.ttf";